/**
   Copyright (c)2021 3Key Company s.r.o., All Rights Reserved

   It is strictly prohibited to distribute the source code,
   transpiled and compiled code or its parts without previous
   agreement of the 3Key Company board.
*/

import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CompanyModel } from "data/models/CompanyModel";


export interface CompaniesState {

   companiesLoading: boolean;
   companies: CompanyModel[];

   companyLoading: boolean;

   selectedCompany?: CompanyModel;

   companyUpdating: boolean;


}


const initialState: CompaniesState = {

   companiesLoading: false,
   companies: [],

   companyLoading: false,
   companyUpdating: false,

}


export const slice = createSlice({

   name: "companies",

   initialState,

   reducers: {

      loadCompanies: state => {
         state.companiesLoading = true;
      },

      companiesLoaded: (state, action: PayloadAction<{ companies: CompanyModel[] }>) => {
         state.companiesLoading = false;
         state.companies = action.payload.companies;
      },

      companiesLoadingError: (state, action: PayloadAction<{err: any}>) => {
         state.companiesLoading = false;
         console.error(action.payload.err);
      },

      loadCompany: (state, action: PayloadAction<{ id: string }>) => {
         state.companyLoading = true;
      },

      companyLoaded: (state, action: PayloadAction<{ company: CompanyModel }>) => {
         state.companyLoading = false;
         const index = state.companies.findIndex(c => c.id === action.payload.company.id);
         if (index >=0 ) {
            if (state.selectedCompany === state.companies[index]) state.selectedCompany = action.payload.company;
            state.companies[index] = action.payload.company;
         } else {
            state.companies.push(action.payload.company);
         }
      },

      companyLoadingError: (state, action: PayloadAction<{ err: any }>) => {
         state.companyLoading = false;
         console.error(action.payload.err);
      },

      selectCompanyById: (state, action: PayloadAction<{ id: string }>) => {
         state.selectedCompany = state.companies.find(c => c.id === action.payload.id);
      },

      selectCompanyByName: (state, action: PayloadAction<{ companyName: string }>) => {
         state.selectedCompany = state.companies.find(c => c.companyName === action.payload.companyName);
      },

      updateCompany: (state, action: PayloadAction<{ company: CompanyModel }>) => {
         state.companyUpdating = true;
      },

      companyUpdated: (state, action: PayloadAction<{ company: CompanyModel }>) => {

         state.companyUpdating = false;
         const index = state.companies.findIndex(c => c.id === action.payload.company.id);

         if (index >=0 ) {
            state.companies[index] = action.payload.company
            if (state.selectedCompany && state.selectedCompany.id === action.payload.company.id) state.selectedCompany = action.payload.company;
         } else {
            console.error(`Failed to update a company state. Company Id ${action.payload.company.id} not found`);
         }

      },

      companyUpdateError: (state, action: PayloadAction<{ err: any }>) => {
         state.companyUpdating = false;
         console.error(action.payload.err);
      },


   }

});


export const actions = slice.actions;

export default slice.reducer;



